import {COMMON_KEYS} from './common-keys';
import {COOKIE_KEYS} from './cookie-keys';
import {DEALER_KEYS} from './dealer-keys';
import {ERROR_KEYS, BFF_ERROR_VALUES} from './error-keys';
import {EVENT_KEYS} from './event-keys';
import {
  BLUETOOTH_KEYS,
  MAKE_KEYS,
  MISC_KEYS,
  OC_LEAD_META_KEYS,
  RADIO_OPTIONS_KEYS,
  ONSTAR_KEYS,
  CHROME_MMY_VALUES_KEY
} from './other-keys';
import {VEHICLE_KEYS} from './vehicle-keys';
import {MYPLANS_KEYS} from './myplans-keys';
import {PDP_KEYS} from './pdp-keys';
import {EMSP_KEYS} from './emsp-keys';
import {CHECKOUT_KEYS} from './checkout-keys';

enum TAB_DETAIL_ITEM_KEYS {
  GFA_NUMBER = 'gfaNumber',
  SUBJECT = 'subject',
  CLASSIFICATION = 'classification',
  VIN_STATUS_INFO = 'vinStatusInfo',
  CLOSING_DATE = 'closingDate',
  RELEASE_BUSINESS_UNIT_INFO = 'releaseBusinessUnitInfo',
  RECALL_CENTER_RELEASED = 'recallCenter_released',
  RECALL_CENTER_COMPLETED = 'recallCenter_completed',
  RELEASE_DATE = 'releaseDate',
  DESCRIPTION = 'description',
  STATUS = 'status',
  START_DATE = 'startDate',
  END_DATE = 'expirationDate',
  START_MILEAGE = 'startMileage',
  END_MILEAGE = 'endMileage',
  ACTIVE = 'Applicable',
  EXPIRED = 'Expired',
  NA = 'Not Applicable',
  WARRANTY_EXPIRED_LABEL = 'warrantyCenter_expired',
  WARRANTY_ACTIVE_LABEL = 'warrantyCenter_active',
  MY_CURRENT_PLANS_KEY = 'myCurrentPlan'
}

export const OX_KEYS = {
  ...COMMON_KEYS,
  ...MISC_KEYS,
  ERROR: ERROR_KEYS,
  BLUETOOTH: BLUETOOTH_KEYS,
  COOKIE: COOKIE_KEYS,
  DEALER: DEALER_KEYS,
  EVENT: EVENT_KEYS,
  MAKE: MAKE_KEYS,
  OC_LEAD_META: OC_LEAD_META_KEYS,
  RADIO_OPTIONS: RADIO_OPTIONS_KEYS,
  ONSTAR: ONSTAR_KEYS,
  VEHICLE: VEHICLE_KEYS,
  TAB_DETAIL_ITEM: TAB_DETAIL_ITEM_KEYS,
  CHROME_MMY_VALUES: CHROME_MMY_VALUES_KEY,
  MY_PLANS: MYPLANS_KEYS,
  B2C_ERROR: {BFF: {...BFF_ERROR_VALUES}},
  PDP: PDP_KEYS,
  EMSP: EMSP_KEYS,
  CHECKOUT: CHECKOUT_KEYS
} as const;
